import {
  Component,
} from "react";
import {
  Alert,
  Button,
  Form,
  Modal,
} from "react-bootstrap";
import {
  ControlGenerators,
} from "CommonComponents/detail-view";
import {
  Spinner,
} from "CommonComponents/bricks";
import apifetch from "CommonCore/apifetch";
import massnahmeApi from "Apis/massnahme-api";
import moment from "moment";

@massnahmeApi.current
export default class MnÄndernPopup extends Component {
  /*
   * Popup, in dem man Änderungen an der Maßnahme direkt in PBP durchführt
   * Eingeführt, nachdem die Bearbeitung von Maßnahmen im e-Portal abgeschaltet wurde (PBP-1406)
   */
  constructor() {
    super();
    this.state = { seite: 1, entity: {} };
  }

  componentDidMount() {
    const { currentMassnahme: mn } = this.props;
    this.setState({ entity: { datum: mn.m_gueltigab, vorher: mn.m_gueltigab, ende_vorher: mn.m_gueltigbis, end_datum: mn.m_gueltigbis } });
  }

  getGültigBis = gueltigAbNeu => {
    // neues Enddatum berechnen
    const { vorher, ende_vorher } = this.state.entity;
    const mNeu = new moment(ende_vorher);
    const diff = new moment(gueltigAbNeu).diff(new moment(vorher), "days");
    if (diff) {
      mNeu.add(diff, "days");
    }
    return mNeu.format("YYYY-MM-DD");
  };

  render() {
    const { onClose, currentMassnahme } = this.props;
    const { entity, errorMessage, seite, inflight } = this.state;

    if (!entity.datum) {
      return null;
    }

    const schema = { field: "datum", display: "Neues Beginn-Datum", type: "date" };
    const schema_end_date = { field: "end_datum", display: "Neues Ende-Datum", type: "date" };

    return (
      <Modal show onHide={onClose}>
        <Modal.Header>
          Beginndatum der Maßnahme anpassen
        </Modal.Header>
        <Modal.Body>
          {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}

          { seite == 1 && <span><h4>Bitte geben Sie das gewünschte Beginndatum ein:</h4>
            <Form className='form-horizontal'>
              {ControlGenerators.date({ entity: entity,
                                        schema: schema,
                                        onChange: this.onChange,
                                        message: this.state.validationErrors && this.state.validationErrors.mn_gueltigab,
                                        key: "datum_beginn" })}
              {currentMassnahme && currentMassnahme.m_endefix === false ? <span><b>Hinweis:</b> Mit Änderung des Beginn-Datums wird automatisch das Ende-Datum ebenfalls verschoben. Bitte prüfen Sie mit der Person, die die Finanzierung bestätigt hat, ob die Mittel über den gewählten Zeitraum hinaus zur Verfügung stehen.</span> : ""}
              {currentMassnahme && currentMassnahme.m_endefix === false && ControlGenerators.date({ entity: entity,
                                                                                                    schema: schema_end_date,
                                                                                                    onChange: this.onChangeEndDate,
                                                                                                    message: this.state.validationErrors && this.state.validationErrors.mn_gueltigbis,
                                                                                                    key: "datum_ende" })}
              {currentMassnahme && currentMassnahme.m_endefix === false && <span><b>Hinweis:</b> Das Ende-Datum wird auf Basis des exakten Zeitraums (Anzahl Tage) ermittelt und sollte nur in Ausnahmefällen geändert werden.</span>}
            </Form></span>
          }

          { seite == 2 && inflight && <span>Bitte warten, die Daten werden aktualisiert ...</span>}

          { !inflight && seite == 2 && <span>Die Anfrage wird nun an PBP übertragen und dort verarbeitet. Sobald die Daten verarbeitet wurden, bekommen Sie hier die aktualisierten Zeiträume angezeigt.
          </span>
          }


        </Modal.Body>
        <Modal.Footer>
          { seite == 1 && <span>  <Button variant='primary' onClick={this.onConfirm} disabled={inflight || !entity.datum || entity.datum == entity.vorher}>
            { inflight ? <Spinner /> : "Beginn verschieben"}
          </Button>
          <Button disabled={ inflight } variant='link' onClick={this.onCancel}>Schließen</Button></span> }

          { seite == 2 && <Button variant='primary' disabled={ inflight } onClick={this.onImport }>{ inflight ? <Spinner /> : "Zurück zur Maßnahme"}</Button> }

        </Modal.Footer>
      </Modal>
    );
  }

  onChange = (fld, value) => {
    const { entity } = this.state;
    entity.datum = value;
    entity.end_datum = this.getGültigBis(value);
    this.setState({ entity });
  };
  onChangeEndDate = (fld, value) => {
    const { entity } = this.state;
    entity.end_datum = value;
    this.setState({ entity });
  };

  onConfirm = async() => {
    // Service-Kommunikation

    /*
     *  PBP-1669: Datum muss nicht hinter dem vorherigen liegen, nur in der Zukunft
     * if (new moment(this.state.datum,'YYYY-MM-DD').isBefore(new moment(this.state.vorher,'YYYY-MM-DD'))) {
     */

    const { entity } = this.state;

    if (new moment(entity.datum, "YYYY-MM-DD").isBefore(new moment())) {
      this.setState({ validationErrors: { mn_gueltigab: "Das neue Datum muss in der Zukunft liegen." } });
      return false;
    }
    if (new moment(entity.end_datum, "YYYY-MM-DD").isBefore(new moment(this.state.datum, "YYYY-MM-DD"))) {
      this.setState({ validationErrors: { mn_gueltigbis: "Das neuen Ende-Datum muss nach der Beginn-Datum liegen." } });
      return false;
    }

    this.setState({ inflight: true, errorMessage: null });

    const data = {
      mn_id: this.props.currentMassnahme.m_id, mn_gueltigab: entity.datum,
    };
    if (entity.end_datum) {
      data.mn_gueltigbis = entity.end_datum;
    }

    try {
      await apifetch("/api/shkexport/pbpmassnahme/datum", {
        method: "POST",
        body: data,
      });
      this.setState({ seite: 2, inflight: false }); // Bestätigungs-/Import-Seite
    } catch(err) {
      this.setState({
        inflight: false,
        validationErrors: null,
        errorMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
      });
    }
  };
  onCancel = () => {
    this.props.onCancel();
  };

  onImport = async() => {
    // Service-Kommunikation zwecks Import

    try {
      this.setState({ inflight: true, errorMessage: null });
      await apifetch("/api/shkimport/massnahme");
      this.setState({ inflight: false });
      this.props.onClose(this.state.datum);
    } catch(err) {
      this.setState({
        validationErrors: null,
        inflight: false,
        errorMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
      });
    }
  };
}
